import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpRequest, HttpResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { LocalStorageService } from 'angular-2-local-storage';
import { environment } from '../../../environments/environment';
import { Observable, of, throwError } from 'rxjs';

@Injectable()
export class ClientApiService {
  readonly apiUrl = environment.apiUrl;
  token: string;
  constructor(
    private http: HttpClient,
    private router: Router,
    private notify: NotificationsService,
    private localStorageService: LocalStorageService
  ) { }
  eraseToken() {
    this.token = null;
  }
  errorNotify(error: any) {
    const err = error.error.error;
    console.log(error.error);
    if (err) {
      this.notify.error(err.code, err.message);
    } else if (error.error.errors) {
      const errs = error.error.errors;
      let msg = '';
      errs.forEach(el => {
        msg += el.property_path + ':' + el.message + '\n';
      });
      this.notify.error('Invalid fields', msg);
    } else {
      this.notify.error(error.status, error.error);
    }
  }
  errorHandler(error: HttpResponse<HttpErrorResponse> | any): Observable<any> {
    this.errorNotify(error);
    if (error.status && error.status === 403) {
      this.eraseToken();
      console.log(error, error.status);
      this.router.navigate(['/login']);
    } else if (error.status && error.status === 500) {
      console.log(error, error.status);
      this.eraseToken();
      this.localStorageService.remove('userProfile');
      this.localStorageService.remove('userPermissions');
      this.router.navigate(['/login']);
    } else if (error.status === 201) {
      const httpResponse = new HttpResponse({
        body: {
          status: true,
          message: error.statusText
        }
      });
      return of(httpResponse);
    }
    return throwError(error);
  }

  get(url: string, options = {}): Observable<any> {
    return this.http.get(this.apiUrl + url, options);
  }

  post(url: string, body = null, options = {}): Observable<any> {
    return this.http.post(this.apiUrl + url, body, options);
  }

  postStatic(url: string, body = null, options = {}): Observable<any> {
    let filesApiUrl = environment.apiUrl;
    if (environment.production) {
      filesApiUrl = environment.altApiUrl;
    }
    return this.http.post(filesApiUrl + url, body, options);
  }

  put(url: string, body = null, options = {}): Observable<any> {
    return this.http.put(this.apiUrl + url, body, options);
  }

  patch(url: string, body = null, options = {}): Observable<any> {
    return this.http.patch(this.apiUrl + url, body, options);
  }

  delete(url: string, options = {}): Observable<any> {
    console.log(this)
    return this.http.delete(this.apiUrl + url, options);
  }

  deleteStatic(url: string, options = {}): Observable<any> {
    return this.http.delete(environment.altApiUrl + url, options);
  }

  request(req: HttpRequest<any>): Observable<any> {
    return this.http.request(req);
  }

  jsonp(url: string, callbackName: string): Observable<any> {
    return this.http.jsonp(url, callbackName);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/api/api.service.ts